// >>> auth-trace (検証用、後で `>>> auth-trace` ～ `<<< auth-trace` を含む全ブロックを削除)
import Vue from "vue";
// <<< auth-trace

const CHANNEL_NAME = "user-sync";
const STORAGE_KEY = "user";

/**
 * localStorage からユーザー情報を取得する
 * @returns {object|null} UserInfo、無い/パース失敗時は null
 */
export function getCachedUser() {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    // if (!stored) return null;
    // return JSON.parse(stored);
    if (!stored) {
      // >>> auth-trace
      Vue.$log.info("[auth-trace] getCachedUser: empty");
      // <<< auth-trace
      return null;
    }
    const parsed = JSON.parse(stored);
    // >>> auth-trace
    Vue.$log.info("[auth-trace] getCachedUser: hit", {
      enterpriseId: parsed && parsed.enterpriseId,
      accountId: parsed && parsed.accountId,
    });
    // <<< auth-trace
    return parsed;
  } catch (e) {
    // >>> auth-trace
    Vue.$log.warn("[auth-trace] getCachedUser: parse error", { e });
    // <<< auth-trace
    return null;
  }
}

/**
 * UserInfo を localStorage に保存し、BroadcastChannel で通知する
 * @param {object} userInfo
 */
export function broadcastUser(userInfo) {
  // >>> auth-trace
  Vue.$log.info("[auth-trace] broadcastUser", {
    enterpriseId: userInfo && userInfo.enterpriseId,
    accountId: userInfo && userInfo.accountId,
  });
  // <<< auth-trace
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(userInfo));
  } catch (e) {
    // localStorage 非対応/容量超過時は無視
    // >>> auth-trace
    Vue.$log.warn("[auth-trace] broadcastUser: localStorage write failed", {
      e,
    });
    // <<< auth-trace
  }
  try {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.postMessage({ type: "USER_UPDATED", payload: userInfo });
    channel.close();
  } catch (e) {
    // BroadcastChannel 非対応環境では無視
    // >>> auth-trace
    Vue.$log.warn("[auth-trace] broadcastUser: channel send failed", { e });
    // <<< auth-trace
  }
}

/**
 * localStorage からユーザー情報を削除し、BroadcastChannel で通知する
 */
export function broadcastLogout() {
  // >>> auth-trace
  Vue.$log.info("[auth-trace] broadcastLogout");
  // <<< auth-trace
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // 無視
    // >>> auth-trace
    Vue.$log.warn("[auth-trace] broadcastLogout: localStorage remove failed", {
      e,
    });
    // <<< auth-trace
  }
  try {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.postMessage({ type: "USER_LOGGED_OUT" });
    channel.close();
  } catch (e) {
    // 無視
    // >>> auth-trace
    Vue.$log.warn("[auth-trace] broadcastLogout: channel send failed", { e });
    // <<< auth-trace
  }
}
